import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {take} from 'rxjs/operators';
import {AventiObject} from 'src/app/models/AventiObject';
import {Objecttype} from 'src/app/models/Objecttype';
import {ExcelService} from 'src/app/services/excel.service';
import {ObjectService} from 'src/app/services/object.service';
import {SharedService} from 'src/app/services/shared.service';
import {SnackbarService} from 'src/app/services/snackbar.service';
import {firstValueFrom} from 'rxjs';
import {Table} from 'primeng/table';

enum keys {
  all = 'all',
  new = 'new',
  changes = 'changes',
  error = 'error'
}

@Component({
  selector: 'app-new-objects-multiple',
  templateUrl: './new-objects-multiple.component.html',
  styleUrls: ['./new-objects-multiple.component.css'],
})

export class NewObjectsMultipleComponent implements OnInit, OnDestroy {
  @ViewChild('pTable') pTable: Table;

  Form = new UntypedFormGroup({
    // no: new FormControl('', [Validators.required]),
    name: new UntypedFormControl('', [Validators.required]),
    desc: new UntypedFormControl('', []),
    type: new UntypedFormControl('', [Validators.required]),
    process: new UntypedFormControl('', []),
  });
  @Input() data: any[];
  dataFrontend: any[];
  dataChanges: any[];
  dataNew: any[];
  dataError: any[];
  key: keys;
  objecttypes: Objecttype[];
  isLoading = true;
  readyToSave = false;
  duplicateTfmTags: string[];
  duplicateRdsTags: string[];
  disableButtons = false;
  errorMessage: string;
  errormessage = '';
  objectnotfound = 0;
  existingObjects: AventiObject[];
  private validateInterval: any;

  constructor(
    private sharedservice: SharedService,
    private snackbarservice: SnackbarService,
    private objectservice: ObjectService,
    private excelservice: ExcelService,
    public dialogRef: MatDialogRef<NewObjectsMultipleComponent>,
  ) {
  }

  get no() {
    return this.Form.get('no');
  }

  get name() {
    return this.Form.get('name');
  }

  get tfmTag() {
    return this.Form.get('tfmTag');
  }

  get rdsTag() {
    return this.Form.get('rdsTag');
  }

  get desc() {
    return this.Form.get('desc');
  }

  get type() {
    return this.Form.get('type');
  }

  get process() {
    return this.Form.get('process');
  }

  ngOnDestroy(): void {
    if (this.validateInterval) {
      clearInterval(this.validateInterval);
    }
  }

  async ngOnInit(): Promise<void> {
    this.existingObjects = await firstValueFrom(this.sharedservice.objects.pipe(take(1)));
    const types = await firstValueFrom(this.sharedservice.objecttypes.pipe(take(1)));
    if (types !== null) {
      this.dataChanges = [];
      this.dataNew = [];
      for (const d of this.data) {
        if (d.type && !d.type.id) {
          for (const type of types) {
            if (type.name === d.type) {
              d.type = type;
            }
          }
        }
        if (d.objectid) {
          d.change = 'error';
          for (const object of this.existingObjects) {
            if (d.objectid === object.id) {
              d.change = '';
              if (d.name !== object.name) {
                d.old_name = object.name || '';
                d.change = 'change';
              }
              if (d.tfmTag !== object.tfmTag) {
                d.old_tfmTag = object.tfmTag || '';
                d.change = 'change';
              }
              if (d.rdsTag !== object.rdsTag) {
                d.old_rdsTag = object.rdsTag || '';
                d.change = 'change';
              }
              if (d.process !== object.process) {
                d.old_process = object.process || '';
                d.change = 'change';
              }
              if (d.type?.name !== object.type?.name || d.type?.id !== object.type?.id) {
                console.log('d.type', d.type);
                console.log('object.type', object.type);
                d.old_type = JSON.parse(JSON.stringify(object.type)) || {id: null, name: ''};
                d.change = 'change';
                // tslint:disable-next-line:max-line-length
                d.type = JSON.parse(JSON.stringify(types.find(type => type.id === object.type?.id) || {
                  id: null,
                  name: '',
                  category: null
                }));
              }
              if (d.desc !== object.desc) {
                d.old_desc = object.desc || '';
                d.change = 'change';
              }
              if (d.profilenumber !== object.profilenumber) {
                d.old_profilenumber = object.profilenumber || '';
                d.change = 'change';
              }
              if (d.drawing !== object.drawing) {
                d.old_drawing = object.drawing || '';
                d.change = 'change';
              }
              if (d.comment !== object.comment) {
                d.old_comment = object.comment || '';
                d.change = 'change';
              }
            }
          }
          if (d.change === 'change') {
            this.dataChanges.push(d);
          }
        } else {
          d.change = 'new';
          if (typeof d.type === 'string') {
            const oldType = d.type;
            // tslint:disable-next-line:max-line-length
            d.type = JSON.parse(JSON.stringify(types.find(type => type.name === oldType) || {id: null, name: '', category: null}));
            if (d.type.id === null) {
              d.old_type = {id: null, name: oldType};
            }
          }
          this.dataNew.push(d);
        }
        if (d.change === 'error') {
          this.objectnotfound++;
        }
      }
      this.objecttypes = types.filter(type => type.category?.id !== 'loJgvvKxjzx1jk771Wuf' && type.active !== false); // Filter out Mottak category and deactivated types
      this.validateForm();
      if (this.dataError.length > 0) {
        this.updateKey(keys.error);
      } else if (this.dataChanges.length > 0) {
        this.updateKey(keys.changes);
      } else if (this.dataNew.length > 0) {
        this.updateKey(keys.new);
      } else {
        this.updateKey(keys.all);
      }
      this.isLoading = false;
    }

    this.validateInterval = setInterval(() => {
      this.validateForm();
    }, 2000);
  }

  async saveObjects() {
    let readyToSave = true;
    const objects: Partial<AventiObject>[] = [];
    const objectsToSave = [...this.dataNew, ...this.dataChanges];
    for (const o of objectsToSave) {
      if (!o.type?.id) {
        readyToSave = false;
      }
      if (!o.name) {
        readyToSave = false;
      }

      const updatedFields: Partial<AventiObject> = {};

      if (o.change === 'change') {
        if (o.old_name != null && o.name !== o.old_name) {
          updatedFields.name = o.name || '';
        }
        if (o.old_tfmTag != null && o.tfmTag !== o.old_tfmTag) {
          updatedFields.tfmTag = o.tfmTag || '';
        }
        if (o.old_rdsTag != null && o.rdsTag !== o.old_rdsTag) {
          updatedFields.rdsTag = o.rdsTag || '';
        }
        if (o.old_process != null && o.process !== o.old_process) {
          updatedFields.process = o.process || '';
        }
        if (o.old_type != null && o.type?.id != null && (o.type?.id !== o.old_type.id || o.type?.name !== o.old_type.name)) {
          updatedFields.type = this.objecttypes.find(type => type.id === o.type?.id) || {id: null, name: '', category: null};
          delete updatedFields.type.editedBy;
        }
        if (o.old_desc != null && o.desc !== o.old_desc) {
          updatedFields.desc = o.desc || '';
        }
        if (o.old_profilenumber != null && o.profilenumber !== o.old_profilenumber) {
          updatedFields.profilenumber = o.profilenumber || '';
        }
        if (o.old_drawing != null && o.drawing !== o.old_drawing) {
          updatedFields.drawing = o.drawing || '';
        }
        if (o.old_comment != null && o.comment !== o.old_comment) {
          updatedFields.comment = o.comment || '';
        }
      } else if (o.change === 'new') {
        // If it's a new object, include all fields
        updatedFields.name = o.name || '';
        updatedFields.tfmTag = o.tfmTag || '';
        updatedFields.rdsTag = o.rdsTag || '';
        updatedFields.process = o.process || '';
        updatedFields.type = o.type || '';
        updatedFields.desc = o.desc || '';
        updatedFields.profilenumber = o.profilenumber || '';
        updatedFields.drawing = o.drawing || '';
        updatedFields.comment = o.comment || '';
      } else {
        // If the object is not changed, we skip it
        console.log('Skipping unchanged object:', o);
        continue;
      }

      if (Object.keys(updatedFields).length > 0) {
        if (o.change === 'change') {
          updatedFields.id = o.objectid || o.id || null;
        }
        objects.push(updatedFields);
      }
    }
    console.log('Objects to save:', objects.length);
    if (readyToSave) {
      this.errormessage = '';
      this.disableButtons = true;
      await this.objectservice.importObjects(objects);
      this.dialogRef.close();
      // if (result === 'success') {
      //   window.location.reload();
      // }
    } else {
      this.snackbarservice.openSnackBar('Fyll ut alle objekttyper', '');
      this.errormessage = 'Fyll ut alle objekttyper';
    }
  }

  downloadChangeInObjects() {
    this.excelservice.exportAsExcelFile(this.data, 'endringslogg');
  }

  updateKey(eventKey: string) {
    if (eventKey !== this.key) {
      switch (eventKey) {
      case keys.all:
        this.key = eventKey;
        this.dataFrontend = this.data;
        break;
      case keys.new:
        this.key = eventKey;
        this.dataFrontend = this.dataNew;
        break;
      case keys.changes:
        this.key = eventKey;
        this.dataFrontend = this.dataChanges;
        break;
      case keys.error:
        this.key = eventKey;
        this.dataFrontend = this.dataError;
        break;
      default:
        console.error(`Unknown key: ${eventKey}`);
      }
    }
    if (this.pTable && this.pTable.paginator) {
      this.pTable.first = 0; // Set the first page index
    }
  }

  // Helper to safely trim values for template use
  safeTrim(value: any): string {
    return typeof value === 'string' ? value.trim() : '';
  }

  private validateForm() {
    // Duplicate detection
    const tfmTagCount: Record<string, number[]> = {};
    const rdsTagCount: Record<string, number[]> = {};
    let objectsWithoutName = 0;
    let objectsWithoutType = 0;
    const dataErrorSet = new Set<any>();

    // Build sets of existing names/tfmTags/rdsTags for duplicate check
    const existingTfmTags = new Set<string>();
    const existingRdsTags = new Set<string>();
    if (this.existingObjects) {
      for (const obj of this.existingObjects) {
        if (obj.tfmTag && typeof obj.tfmTag === 'string' && obj.tfmTag.trim() !== '') {
          existingTfmTags.add(obj.tfmTag.trim());
        }
        if (obj.rdsTag && typeof obj.rdsTag === 'string' && obj.rdsTag.trim() !== '') {
          existingRdsTags.add(obj.rdsTag.trim());
        }
      }
    }

    for (let i = 0; i < this.data.length; i++) {
      const o = this.data[i];
      // Check for missing name/type
      if (!o.name || (typeof o.name === 'string' && o.name.trim() === '')) {
        objectsWithoutName++;
        dataErrorSet.add(o);
      }
      if (!o.type || !o.type.id) {
        objectsWithoutType++;
        dataErrorSet.add(o);
      }
      // Track indices for duplicates (ignore empty/null)
      if (o.tfmTag && typeof o.tfmTag === 'string' && o.tfmTag.trim() !== '') {
        const key = o.tfmTag.trim();
        if (!tfmTagCount[key]) {
          tfmTagCount[key] = [];
        }
        tfmTagCount[key].push(i);
      }
      if (o.rdsTag && typeof o.rdsTag === 'string' && o.rdsTag.trim() !== '') {
        const key = o.rdsTag.trim();
        if (!rdsTagCount[key]) {
          rdsTagCount[key] = [];
        }
        rdsTagCount[key].push(i);
      }
    }

    // Only consider as duplicate if the value appears in more than one object or exists in existingObjects
    this.duplicateTfmTags = Object.keys(tfmTagCount).filter(k => tfmTagCount[k].length > 1 || existingTfmTags.has(k));
    this.duplicateRdsTags = Object.keys(rdsTagCount).filter(k => rdsTagCount[k].length > 1 || existingRdsTags.has(k));

    // Add objects with duplicate values to error set
    this.duplicateTfmTags.forEach(tag => tfmTagCount[tag].forEach(idx => dataErrorSet.add(this.data[idx])));
    this.duplicateRdsTags.forEach(tag => rdsTagCount[tag].forEach(idx => dataErrorSet.add(this.data[idx])));

    // Count unique duplicate values
    const objectsWithDuplicateTfmTag = this.duplicateTfmTags.length;
    const objectsWithDuplicateRdsTag = this.duplicateRdsTags.length;
    this.readyToSave =
      objectsWithoutName === 0 &&
      objectsWithoutType === 0 &&
      objectsWithDuplicateTfmTag === 0 &&
      objectsWithDuplicateRdsTag === 0;
    this.dataError = Array.from(dataErrorSet);

    console.log(`Objects without name: ${objectsWithoutName}`);
    console.log(`Objects without type: ${objectsWithoutType}`);
    console.log(`Unique duplicate TFM Tag: ${objectsWithDuplicateTfmTag}`);
    console.log(`Unique duplicate RDS Tag: ${objectsWithDuplicateRdsTag}`);
    if (objectsWithDuplicateTfmTag > 0) {
      console.log(`Duplicate TFM Tags: ${this.duplicateTfmTags.join(', ')}`);
    }
    if (objectsWithDuplicateRdsTag > 0) {
      console.log(`Duplicate RDS Tags: ${this.duplicateRdsTags.join(', ')}`);
    }

    const errorParts = [];
    if (objectsWithoutName > 0) {
      errorParts.push(`Antall objekter uten navn: ${objectsWithoutName}`);
    }
    if (objectsWithoutType > 0) {
      errorParts.push(`Antall objekter uten type: ${objectsWithoutType}`);
    }
    if (objectsWithDuplicateTfmTag > 0) {
      errorParts.push(`Duplikate TFM Tag: ${objectsWithDuplicateTfmTag}`);
    }
    if (objectsWithDuplicateRdsTag > 0) {
      errorParts.push(`Duplikate RDS Tag: ${objectsWithDuplicateRdsTag}`);
    }
    this.errorMessage = errorParts.length > 0 ? errorParts.join(', ') : '';
    console.log(`Validation results: ${this.errorMessage}`);
  }
}
